import AbstractGuestlistDetailsPageController from './abstract-details-controller';
import guestlistModelReducer from '../../../helpers/guestlist-model-reducer';
import moment from 'moment';

export default class GuestlistReleaseSettingsPageController extends AbstractGuestlistDetailsPageController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.api = $injector.get('$http');
        this.queue = $injector.get('$q');
        this.state = $injector.get('$state');
        this.growl = $injector.get('growl');
        this.depositService = $injector.get('Deposit');
        this.company = _.get($injector.get('Users'), 'state.company');
        this.scope = $scope;
        this.injector = $injector;

        this.registrationType = {};
        this.initialized = false
        this.model = {};
        this._setupDropDownConfigs()

        this.selectLists = {
            categories: [],
            ticketTemplates: [],
            guestlistObjects: []
        };
        this.rsvpStates = [];

        this.registrationTypes = [
            {
                label: 'Open',
                values: {
                    enable_code_registration: true,
                    enable_open_registration: true,
                    enable_logged_in_registration: false
                }
            },
            {
                label: 'Login',
                values: {
                    enable_code_registration: true,
                    enable_open_registration: false,
                    enable_logged_in_registration: true
                }
            },
            {
                label: 'Open & Login',
                values: {
                    enable_code_registration: true,
                    enable_open_registration: true,
                    enable_logged_in_registration: true
                }
            },
            {
                label: 'Invitation only',
                values: {
                    enable_code_registration: true,
                    enable_open_registration: false,
                    enable_logged_in_registration: false
                }
            }
        ];

        this.realMunichEnabled = _.get(this.userStore.state, 'company.settings.lp-api.enable_real_munich_reservation')

        this._initWatchers();
    }

    _handleGuestlistSelect() {
        super._handleGuestlistSelect();

        this.model = guestlistModelReducer(this.guestlist);
        _.forEach(this.registrationTypes, (curType) => {
            if (Boolean(this.model.settings.enable_code_registration) === curType.values.enable_code_registration
                && Boolean(this.model.settings.enable_open_registration) === curType.values.enable_open_registration
                && Boolean(this.model.settings.enable_logged_in_registration) === curType.values.enable_logged_in_registration) {
                this.registrationType = curType;
            }
        });

        _.each(this.model.seatplan_area_infos, (areaInfo) => {
            areaInfo.start = moment(areaInfo.start);
            areaInfo.end = moment(areaInfo.end);
        });
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.registrationType;
        }, (newValue) => {
            _.forEach(newValue.values, (v, k) => {
                this.model.settings[k] = v;
            });
        });
    }

    save() {
        this.api.put(`guestlists/${this.model.id}`, this.prepareDataForApi()).then(() => {
            this.growl.success('', {title: 'Saved'});
            this.state.go('app.guestlists.rsvps.index', {
                gid: this.model.id,
                guestlist: null
            })
        }, () => {
            this.growl.error('Please try again.', {title: 'Error'});
        })
    }

    prepareDataForApi() {
        const apiData = _.cloneDeep(this.model);

        _.each(apiData.seatplan_area_infos, (areaInfo) => {
            areaInfo.start = moment(areaInfo.start).tz('UTC').format();
            areaInfo.end = moment(areaInfo.end).tz('UTC').format();
        });

        return apiData;
    }

    cancel() {
        this.state.go('app.guestlists.rsvps.seats', {
            gid: this.model.id
        });
    }

    _setupDropDownConfigs() {
        const glId = this.stateParams.gid;

        return new Promise((resolve, reject) => {
            Promise.all([
                this.api.post(
                    `fp/guestlists/${glId}/bo/objects`,
                    {
                        fields: ['id', 'object.label'],
                        pagination: {
                            perPage: -1
                        }
                    }
                ).then((response) => {
                    this.selectLists.guestlistObjects = response.data.data
                        .map((objectRow) => {
                        return {
                            value: objectRow.id,
                            label: objectRow.object.label
                        }
                    })
                }),
                this.api.post(
                    'fp/categories',
                    {
                        fields: ['id', 'name'],
                        pagination: {
                            perPage: -1
                        }
                    }
                ).then((response) => {
                    this.selectLists.categories = response.data.data
                        .map((categoryRow) => {
                            return {
                                value: categoryRow.id,
                                label: categoryRow.name
                            }
                        })
                }),
                this.api.post(
                    'fp/tickets/templates',
                    {
                        fields: ['id', 'name'],
                        pagination: {
                            perPage: -1
                        }
                    }
                ).then((response) => {
                    this.selectLists.ticketTemplates = response.data.data
                        .map((ticketTemplate) => {
                            return {
                                value: ticketTemplate.id,
                                label: ticketTemplate.name
                            }
                        })
                }),
                this.depositService.getRemoteDeposit('rsvps', 'states', []).then((depositRsvpStates) => {
                    const localRsvpStates = [];
                    _.each(depositRsvpStates, (v, k) => {
                        localRsvpStates.push({
                            value: k,
                            label: v
                        })
                    });

                    this.rsvpStates = localRsvpStates;
                })
            ]).then(() => {
                this.initialized = true
                resolve()
            })
        })
    }

    addEmptyRealMunichLimit() {
        this.model.settings.real_munich_reservation_limits.push({
            pax: 8,
            limit: 0
        })
    }

    removeRealMunichLimit(index) {
        this.model.settings.real_munich_reservation_limits.splice(index, 1)
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/guestlists/release-settings-controller.js